import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { Bell, Calendar, Clock } from "lucide-react";
import { useLocation } from "react-router-dom";

const ViewReminders = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchReminders = async () => {
    const patient_id = location.state?.student_id; // changed for admin/student context
    if (!patient_id) return;

    setLoading(true);
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/admin_all_reminder",
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setReminders(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch reminders. Try again later.");
        console.error(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const getReminderTypeLabel = (type) => {
    if (type?.toLowerCase() === "am") return "Morning";
    if (type?.toLowerCase() === "pm") return "Evening";
    if (type?.toLowerCase() === "nt") return "Night";
    return type;
  };

  useEffect(() => {
    fetchReminders();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-gray-50 to-emerald-100">
      <Navbar />

      <div className="flex flex-col pt-28 px-4 pb-10 max-w-6xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-emerald-900 text-center mb-6">
          🧠 Admin Dashboard – Student Reminders
        </h2>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-emerald-500 border-solid" />
          </div>
        ) : reminders.length === 0 ? (
          <div className="text-center text-gray-600 text-lg italic py-10">
            No reminders found for this student.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reminders.map((reminder) => (
              <div
                key={reminder.id}
                className="bg-white rounded-2xl p-5 shadow-md border border-emerald-200 hover:shadow-xl transition duration-300"
              >
                <div className="flex items-center gap-2 mb-2">
                  <Bell className="text-emerald-600 w-5 h-5" />
                  <span className="text-emerald-900 font-medium text-base truncate">
                    {reminder.medicine_name}
                  </span>
                </div>

                <div className="flex items-center text-gray-600 text-sm mb-1">
                  <Calendar className="w-4 h-4 mr-1 text-emerald-500" />
                  {reminder.start_date} – {reminder.end_date}
                </div>

                <div className="flex items-center text-gray-600 text-sm mb-1">
                  <Clock className="w-4 h-4 mr-1 text-emerald-500" />
                  {reminder.time}
                  <span className="ml-2 px-2 py-0.5 bg-emerald-100 text-emerald-800 text-xs rounded-full">
                    {getReminderTypeLabel(reminder.reminder_type)}
                  </span>
                </div>

                <div className="text-gray-700 text-sm mt-2">
                  <strong>Days:</strong>{" "}
                  <span className="text-gray-800">{reminder.reminder_day.join(", ")}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReminders;
